<div class="subtitle-container">
  <app-subtitle
    [subtitleText]="'Energy Restoring'"
    [fontSize]="1.9"
  ></app-subtitle>
</div>
<div class="character-container" *ngIf="characterSlot">
  <app-character-frame
    class="character-frame"
    [characterSlot]="characterSlot"
    [showName]="false"
    [slimFrame]="true"
  ></app-character-frame>
  <div class="character-spec-container" *ngIf="characterSlot.character">
    <span class="name">
      {{ characterSlot.character.name }}
    </span>
    <app-character-energy-scale
      class="energy"
      [character]="characterSlot.character"
    ></app-character-energy-scale>
    <app-hints [hintImage]="'type2'"></app-hints>
  </div>
</div>
<div class="card-list" *ngIf="characterSlot?.character !== undefined">
  <app-restore-bossting-card-list
    class="list"
    [cards]="cards"
    (useCard)="useReplenishment($event)"
  ></app-restore-bossting-card-list>
</div>
